import { render, staticRenderFns } from "./PropertyGroup.vue?vue&type=template&id=0831ecdc"
import script from "./PropertyGroup.vue?vue&type=script&lang=js"
export * from "./PropertyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports